<template>
  <div class="Card-content">
    <div class="Prose">
      <slot></slot>
    </div>
  </div>
</template>

<script setup></script>
